





















































































import { Component, Prop, Vue } from 'vue-property-decorator';
import { Action, Getter, State } from 'vuex-class';
import DropdownInputElement from '../../ui/form/elements/DropdownInputElement.vue';
import BaseNumberInputElement from '../../ui/form/numberinput/BaseNumberInputElement.vue';
import VueSmartSlider from '../../ui/slider/VueSmartSlider.vue';
import { SliderMarker } from '../../ui/slider/types/SliderTypes';
import {
  DashboardState,
  GetServerRequest,
  GetServerResponse,
  UpdateServerRequest,
} from '../../../store/dashboard/types';
import { MutationRequestStatus } from '../../../store/types';
import LoadingAnimation from '../../helper/LoadingAnimation.vue';
import { calculateSliderSteps } from '../../../service/slider';
import BaseAppModal from '../BaseAppModal.vue';
import { CustomInputValidationState } from '../../ui/form/numberinput/BaseNumberInputElementFeatures';
import { Customer } from '../../../store/auth/types';
import { CloudUnitType } from '../../../store/product/types';
// @TODO: replace with composition API and rename to BaseEditUnits to match the Vue Styleguide

@Component({
  components: {
    BaseAppModal, LoadingAnimation, VueSmartSlider, BaseNumberInputElement, DropdownInputElement,
  },
})
export default class EditUnits extends Vue {
  // @TODO: refactor the computed properties to make use of vuex getters
  @Action('dashboard/getServer') readonly requestServer!: (request: GetServerRequest) => Promise<GetServerResponse>;

  @Action('dashboard/updateServer') readonly updateServer!: (request: UpdateServerRequest) => Promise<void>;

  @State('dashboard') readonly dashboard!: DashboardState;

  @Getter('dashboard/server') readonly server!: GetServerResponse;

  @Getter('auth/customer') readonly customer!: Customer;

  @Action('auth/fetchCustomer') readonly fetchCustomer!: () => Promise<void>

  @Prop({ type: Number, required: true }) readonly orderId!: number;

  name = 'EditUnits';

  units = null;

  cloudUnitType: CloudUnitType = null;

  // Starts false and only flips true once THIS instance has loaded its server data. Gating the
  // modal on a local flag (rather than the shared getServer getter) avoids briefly rendering the
  // dialog with a previous server's data before mounted() kicks off the new request.
  showModal = false;

  isModalReady = false;

  get serverSuccess(): boolean {
    return this.dashboard.getServer.status === MutationRequestStatus.SUCCESS;
  }

  get updateLoading(): boolean {
    return this.dashboard.updateServer.status === MutationRequestStatus.LOADING;
  }

  get changesAllowed(): boolean {
    return this.dashboard.getServer.status === MutationRequestStatus.LOADING
      || this.dashboard.updateServer.status === MutationRequestStatus.LOADING;
  }

  get minUnits(): number {
    return Math.min.apply(Math, Object.entries(this.server.units).map(([, value]) => value));
  }

  get maxUnits(): number {
    return Math.max.apply(Math, Object.entries(this.server.units).map(([, value]) => value));
  }

  get isUnitInputValid(): CustomInputValidationState {
    return {
      customValid: this.unitInputValidator(this.units),
      customErrorMessage: this.$t('modal:edit_units.slot_input.validation_error'),
    };
  }

  /**
   * for some unknown reason the backend responds with way to much "units" to display,
   * (i counted 60 for specific games)
   * we have to break it down here
   */
  get sliderMarker(): Array<SliderMarker> {
    return calculateSliderSteps(this.minUnits, this.maxUnits);
  }

  get isConfirmDisabled() {
    return !this.unitInputValidator(this.units);
  }

  unitInputValidator(units: number): boolean {
    return this.serverSuccess && units >= this.minUnits && units <= this.maxUnits;
  }

  onEditUnitsAccept(): void {
    if (!this.unitInputValidator(this.units)) {
      this.$toast.error(this.$t('modal:edit_units.feedback.invalid_units'));
      return;
    }

    this.updateServer({
      orderId: this.orderId,
      units: this.units,
    }).then(() => {
      this.$toast.success(this.$t('modal:edit_units.feedback.success'));
      this.$emit('close-modal');

      // @TODO: reloads the page afterwards, not required when the dashboard is a vue component
      window.setTimeout(() => document.location.reload(), 500);
    }, (error) => {
      // TR-4939: the action rejects with the AxiosError, not a message string. Passing the
      // error object to a success toast rendered an empty, success-colored toast on failure.
      const errorMessage = (error && error.response && error.response.data
        && error.response.data.message) || null;
      this.$toast.error(errorMessage ?? this.$t('modal:edit_units.feedback.error'));
    });
  }

  async mounted(): Promise<void> {
    try {
      const { currentUnits, cloudUnitType } = await this.requestServer({ orderId: this.orderId });
      this.units = currentUnits;
      this.cloudUnitType = cloudUnitType;

      if (this.customer == null) {
        await this.fetchCustomer();
      }

      this.showModal = true;
    } catch (error) {
      // The request can be rejected by the backend (e.g. TV-1651: a paused subscription
      // rejects the Edit-family actions). Surface that message as a toast and close the modal
      // right away — showing the edit dialog (with confirm/cancel) on top of a rejection is
      // confusing (TV-1651 QA), the top-right error message is the only feedback we want here.
      const errorMessage = (error && error.response && error.response.data
        && error.response.data.message) || null;
      this.$toast.error(errorMessage ?? this.$t('modal:edit_units.feedback.error'));
      this.$emit('close-modal');
    }
  }
}
